import React, { useState } from "react";
import { X } from "lucide-react";

// Chip input: Enter/comma adds, Backspace on empty removes last; items 2–40 chars, deduped case-insensitively.
export function KeywordsInput({ value = [], onChange, disabled, testid }) {
  const [v, setV] = useState("");
  const add = (raw) => {
    const parts = raw.split(",").map((s) => s.trim()).filter((s) => s.length >= 2 && s.length <= 40);
    const next = [...value]; parts.forEach((p) => { if (!next.some((x) => x.toLowerCase() === p.toLowerCase())) next.push(p); });
    onChange(next); setV("");
  };
  return (
    <div className={`input-ui flex min-h-[42px] flex-wrap items-center gap-1.5 py-1.5 ${disabled ? "opacity-60" : ""}`} data-testid={testid}>
      {value.map((k) => (
        <span key={k} className="inline-flex items-center gap-1 rounded-full bg-cyan-50 px-2 py-0.5 text-[11px] font-bold text-cyan-700" data-testid={`${testid}-chip-${k}`}>
          {k}{!disabled && <button type="button" onClick={() => onChange(value.filter((x) => x !== k))} aria-label={`Hapus ${k}`} data-testid={`${testid}-remove-${k}`}><X size={11} /></button>}
        </span>
      ))}
      {!disabled && <input value={v} onChange={(e) => setV(e.target.value)} onBlur={() => v.trim() && add(v)} onKeyDown={(e) => { if ((e.key === "Enter" || e.key === ",") && v.trim()) { e.preventDefault(); add(v); } else if (e.key === "Backspace" && !v && value.length) onChange(value.slice(0, -1)); }} placeholder={value.length ? "" : "ketik kata kunci lalu Enter"} className="min-w-[140px] flex-1 bg-transparent text-xs outline-none" maxLength={40} data-testid={`${testid}-input`} />}
    </div>
  );
}
